import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Item = styled.a`
  margin: 10px;
  margin-bottom: 30px;
`;
